import React from 'react'
import AboutCorporate from "../../../Asset/About/about-corporate.jpg"
import "../About.css"

const BottomContent = () => {
    return (
        <>
            <div className='mt-20 2xl:mt-32 pb-16 md:pb-0 w-full flex justify-center'>
                <div id='about-bottom-content' className='md:w-[95%] w-[90%] bg-white flex flex-col-reverse md:flex-row rounded-3xl gap-8 md:gap-0 p-8 md:p-12 2xl:p-16 items-center'>

                    {/* Left Section Here */}
                    <div className='md:w-1/2 flex flex-col text-[var(--purple-blue)] gap-7 2xl:gap-8'>
                        <h1 className='font-ClashGrotesk text-4xl md:text-5xl xl:text-6xl font-medium leading-[1.1]'>
                            Corporates and Groups, we’ve got something for you too
                        </h1>
                        <p className='text-lg md:text-xl 2xl:text-2xl font-medium font-manrope opacity-90 leading-relaxed'>
                            We’d love to hear from you and collaborate on building tailor-made membership offerings that fit your organisation perfectly
                        </p>
                        <button
                            className="bg-[var(--purple-blue)] text-lg 2xl:text-xl text-[var(--white)] font-manrope font-semibold md:w-[65%] w-full py-4 rounded-xl mt-4 hover:opacity-90 transition-opacity"
                            onClick={() => window.location.href = 'mailto:hello@thenetgala.in'}
                        >
                            Schedule a Call Back
                        </button>
                    </div>

                    {/* Right Section Here */}
                    <div className='md:w-1/2 md:mb-10  flex justify-center items-center '>
                        <div className='md:w-[90%] '>
                            <img className='w-full rounded-2xl md:rounded-3xl' src={AboutCorporate} alt="About Corporate" />
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default BottomContent
